import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';

interface Props {
  medicalCenter: string;
  onMedicalCenterChanged: (event: SelectChangeEvent<string>) => void;
}

const MedicalCenterDropdown = ({ medicalCenter, onMedicalCenterChanged }: Props) => {
  return (
    <FormControl sx={{ minWidth: { xs: 150, md: 170 }, mr: { xs: 1, md: 3 } }}>
      <InputLabel id='medicalCenterLabel'>Establecimiento</InputLabel>
      <Select
        labelId='medicalCenterLabel'
        id='medicalCenter'
        value={medicalCenter}
        label='Establecimiento'
        onChange={onMedicalCenterChanged}
      >
        <MenuItem value='sauces'>Sauces</MenuItem>
        <MenuItem value='duran'>Durán</MenuItem>
      </Select>
    </FormControl>
  );
};

export default MedicalCenterDropdown;
